// ./src/azure-storage-blob.ts

// <snippet_package>
// THIS IS SAMPLE CODE ONLY - NOT MEANT FOR PRODUCTION USE
import { BlobServiceClient, ContainerClient } from '@azure/storage-blob';

// THIS IS SAMPLE CODE ONLY - DON'T STORE TOKEN IN PRODUCTION CODE
const sasToken =
  process.env.STORAGE_SAS_TOKEN ||
  'sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2022-05-12T19:38:21Z&st=2021-03-03T11:38:21Z&spr=https&sig=t9O6SHWXNeiQ9sgIOAYQLmtFGWd2HqM09KzTPbAmXKs%3D';
// 'sv=2019-12-12&ss=b&srt=sco&sp=rwdlacx&se=2021-02-26T15:03:14Z&st=2021-02-05T07:03:14Z&spr=https,http&sig=G7lhB93smTXrr185CEWAagG%2BrOhXr9hnxYns6laVYPk%3D'; // Fill string with your SAS token
// 'Am85hrxZdFKt7xOCKCgMe8MislXqOxKzc2kPSUWO2gYC76OgLjzSj7p70EQ9dZTtxQYvu9GubeC8sVAjGNegKA=='; // Fill string with your SAS token

// const containerName = `safelywithpcrtests`;
const storageAccountName = process.env.STORAGE_SOURCE_NAME || 'safelywithblob'; // Fill string with your Storage resource name
// </snippet_package>

// <snippet_isStorageConfigured>
// Feature flag - disable storage feature to app if not configured
export const isStorageConfigured = (containerName) => {
  return !storageAccountName || !sasToken ? false : true;
};
// </snippet_isStorageConfigured>

// <snippet_getBlobsInContainer>
// return list of blobs in container to display
const getBlobsInContainer = async (containerClient, containerName) => {
  const returnedBlobUrls = [];

  // get list of blobs in container
  // eslint-disable-next-line
  for await (const blob of containerClient.listBlobsFlat()) {
    // if image is public, just construct URL
    returnedBlobUrls.push(
      `https://${storageAccountName}.blob.core.windows.net/${containerName}/${blob.name}`
    );
  }

  return returnedBlobUrls;
};
// </snippet_getBlobsInContainer>

// <snippet_createBlobInContainer>

const createBlobInContainer = async (containerClient, file) => {
  // create blobClient for container
  const blobClient = containerClient.getBlockBlobClient(file.name);

  // set mimetype as determined from browser with file upload control
  const options = { blobHTTPHeaders: { blobContentType: file.type } };

  // upload file
  await blobClient.uploadBrowserData(file, options);
};

// </snippet_createBlobInContainer>

// <snippet_uploadFileToBlob>

export const UploadUrl = (containerName, fileName) =>
  `https://${storageAccountName}.blob.core.windows.net/${containerName}/${fileName}?${sasToken}`;
/**
 * @param {*} file
 * @param {safelywithvaccinations || safelywithpcrtests}  containerName
 */
const uploadFileToBlob = async (file, containerName) => {
  if (!file) return [];

  // get BlobService = notice `?` is pulled out of sasToken - if created in Azure portal
  const blobService = new BlobServiceClient(
    `https://${storageAccountName}.blob.core.windows.net/?${sasToken}`
  );

  // get Container - full public read access
  const containerClient = blobService.getContainerClient(containerName);
  // await containerClient.createIfNotExists({
  //   access: 'container',
  // });

  // upload file
  await createBlobInContainer(containerClient, file);

  // get list of blobs in container
  return getBlobsInContainer(containerClient, containerName);
};
// </snippet_uploadFileToBlob>

export default uploadFileToBlob;
